/** Shared metric coordinates: the 2 km fences have a 1 km gap. */
export const PARCEL_POIS = {
  home: { x: 0, y: 0, label: "家" },
  company: { x: 5000, y: 0, label: "公司" }
} as const;
export interface ParcelPosition { x: number; y: number }
export const PARCEL_SPACE = { minX: -3000, minY: -2600, width: 11000, height: 5200, scale: 0.1 };
export function parcelDistance(position: ParcelPosition, poi: keyof typeof PARCEL_POIS) {
  const center = PARCEL_POIS[poi];
  return Math.hypot(position.x - center.x, position.y - center.y);
}
export function parcelPositionAt(poi: keyof typeof PARCEL_POIS, distanceM: number): ParcelPosition {
  return { x: PARCEL_POIS[poi].x - Math.sqrt(3) / 2 * distanceM, y: distanceM / 2 };
}
export function clampParcelPosition(position: ParcelPosition): ParcelPosition {
  return { x: Math.max(-2700, Math.min(7700, position.x)), y: Math.max(-2250, Math.min(2250, position.y)) };
}
